import { DateField, DateFieldProps } from 'components/form'
import React from 'react'
import { DayDelimiterTooltip } from 'view/registro-tardio/components/DayDelimiterTooltip'

import {
  MAX_DATE_VALIDADE_LOTE_IMUNOBIOLOGICO_MESSAGE,
  MIN_DATE_VALIDADE_LOTE_IMUNOBIOLOGICO_MESSAGE,
} from '../constants/constants-loteImunobiologico'
import { getLoteImunobiologicoMaxDate } from '../utils/utils-loteImunobiologico'

export function LoteImunobiologicoValidadeDateField(props: DateFieldProps) {
  const { name, minDate, disabled = false, icon = null } = props

  const maxDateValidadeLote = getLoteImunobiologicoMaxDate(minDate)

  return (
    <DateField
      label='Data de validade'
      name={name}
      icon={icon}
      minDate={minDate}
      maxDate={maxDateValidadeLote}
      required
      calendarProps={{
        renderDay: (day: Date) => (
          <DayDelimiterTooltip
            day={day}
            minDate={minDate}
            maxDate={maxDateValidadeLote}
            minDateMessage={MIN_DATE_VALIDADE_LOTE_IMUNOBIOLOGICO_MESSAGE}
            maxDateMessage={MAX_DATE_VALIDADE_LOTE_IMUNOBIOLOGICO_MESSAGE}
          />
        ),
      }}
      disabled={disabled}
    />
  )
}
